import { apiRequest, USE_MOCKS } from './client'
import type { ServerCapacity } from '@/types'

export async function getServerCapacity(): Promise<ServerCapacity> {
  if (USE_MOCKS) {
    return {
      hostname: 'node-manager-api',
      platform: 'Linux-6.8.0-x86_64',
      python_version: '3.12.8',
      cpu_count: 8,
      load_average_1m: 1.24,
      load_average_5m: 1.02,
      load_average_15m: 0.88,
      memory_total_bytes: 34359738368,
      memory_available_bytes: 21474836480,
      memory_used_percent: 37.5,
      disk_path: '/',
      disk_total_bytes: 536870912000,
      disk_used_bytes: 214748364800,
      disk_free_bytes: 322122547200,
      disk_used_percent: 40,
      mounts: [
        {
          device: '/dev/sdb1',
          mount_point: '/data/archive',
          fs_type: 'xfs',
          total_bytes: 4398046511104,
          used_bytes: 1099511627776,
          free_bytes: 3298534883328,
          used_percent: 25,
        },
        {
          device: '/dev/sda2',
          mount_point: '/',
          fs_type: 'ext4',
          total_bytes: 536870912000,
          used_bytes: 214748364800,
          free_bytes: 322122547200,
          used_percent: 40,
        },
      ],
      process_uptime_seconds: 86400,
      collected_at: new Date().toISOString(),
    }
  }
  return apiRequest<ServerCapacity>('/api/server/capacity')
}
